import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import { setDeliveryDetailsValues } from '../../Actions/Configurator.action';
import { googleAnalyticsProductConfigurator } from '../../Services/googleAnalytics';

const PanelGoodsMarking = (props) => {
  const dispatch = useDispatch();
  const configurator = useSelector((state) => state.configurator);
  const { id, selections, deliveryDetails } = configurator;
  let goodMarkingValue = deliveryDetails && deliveryDetails.goodsMarking || selections && selections[props.setting] || ''
  const [goodsMarkingValue, setGoodsMarkingValue] = useState(goodMarkingValue);

  const update = (e, isBlur) => {
    setGoodsMarkingValue(e);
    dispatch(setDeliveryDetailsValues({ [props.setting]: e }));
    if (isBlur) {
      googleAnalyticsProductConfigurator(props.setting, e.toString(), id);
    }
  };

  const getIconPath = () => {
    return '/ui/images/sprites/be-group.svg#' + props.icon;
  };

  return (
    <section className='configurator-box'>
      <header>
        <svg className='configurator-box__icon'>
          <use href={getIconPath()}></use>
        </svg>
        <h4 className='configurator-box__title'>{translate(props.labelKey)}</h4>
        <input type='text' maxLength='38' className='configurator-box__input' placeholder={translate('configurator.goodsmarking.placeholder')}
          value={goodsMarkingValue} onChange={(event) => { update(event.target.value); }} onBlur={(event) => { update(event.target.value, true); }} />
      </header>
      <div className='configurator-box__content'>
        {translate('configurator.goodsmarking.orderlinemessage')}
      </div>
    </section>
  );
};

export default PanelGoodsMarking;
